'use client'

import React from 'react'

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="lg:max-w-8xl mx-4 my-8 mt-[192px] flex flex-col items-center space-y-16 lg:mx-auto lg:mb-40 lg:grid lg:grid-cols-2 lg:place-content-center lg:place-items-center lg:space-x-10 lg:space-y-0">
      {children}
    </div>
  )
}
